import { getAnchorElementFromEvent } from '@noths/polaris-client-utils';
import type { Dictionary } from '@noths/polaris-dev-ts-recipes';

import { sendGAEvent } from './sendGAEvent';
import type { GAEventWithoutCallback } from './types';
import { linkClickOpensInNewTab } from './util';

export const sendGALinkClickEvent = async <
  T extends Dictionary<T> & Dictionary<GAEventWithoutCallback>,
>(
  evt: React.MouseEvent | React.MouseEvent<HTMLAnchorElement>,
  trackingEventOrEvents: T | T[],
) => {
  const targetNode = getAnchorElementFromEvent(evt);

  if (targetNode) {
    const opensInNewTab = linkClickOpensInNewTab(evt, targetNode as HTMLAnchorElement);
    const { href, target } = targetNode as HTMLAnchorElement;

    if (opensInNewTab) {
      sendGAEvent(trackingEventOrEvents);
    } else {
      evt.preventDefault();
      try {
        await sendGAEvent(trackingEventOrEvents);
        window.location.assign(href);
      } catch {
        window.open(href, target);
      }
    }
  }
};
